import React, { useContext, useReducer } from 'react';
import FullCard from '../../../../components/Card/FullCard';
import { store as mainStore } from '../../../../store';
import { store, actions, reducer, initialState } from './reducer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useHistory, Switch, Route, useLocation } from 'react-router-dom';
import Rejects from './Rejects/Rejects';
import Deposits from './Deposits/Deposits';
import Returns from './Returns/Returns';
import Cancels from './Cancels/Cancels';
import Ready from './Ready/Ready';
import Commissions from './Commissions/Commissions';
import OperatorCommissions from './OperatorsCommissions/Commissions';
import InsuranceExpiry from './InsuranceExpiry/InsuranceExpiry';
import useRules from '../../../../hooks/useRules';
import OnlineUsers from './OnlineUsers/OnlineUsers';
import useTitle from 'hooks/useTitle';
import UserDetails from './OnlineUsers/UserDetails';
import OnlineDrivers from './OnlineDrivers/OnlineDrivers';

const Reports = (props) => {
  // useTitle('گزارش ها');
  const [addTitle] = useTitle('گزارش ها');
  const {
    state: {
      Props: { itemsCountPerPage },
    },
    showMessage,
    showError,
  } = useContext(mainStore);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [rules, hasRule, isAdmin] = useRules();
  const { title, category } = state;
  const { Provider } = store;
  const history = useHistory();
  const allChilds = props.config.childs;
  const parentUrl = `/protected/admin/reports`;
  const location = useLocation();

  React.useEffect(() => {
    if (parentUrl === location.pathname) {
      addTitle('گزارش ها');
      return dispatch({ type: 'CHANGE_TITLE_CATEGORY', payload: initialState });
    }
  }, [location.pathname]);

  return (
    <Provider
      value={{
        state,
        dispatch,
        actions,
        showMessage,
        showError,
        itemsCountPerPage,
      }}
    >
      <FullCard title={title} category={category}>
        <Switch>
          <Route path={`${parentUrl}/operatorCommissions`}>
            <OperatorCommissions />
          </Route>
          <Route path={`${parentUrl}/rejects`}>
            <Rejects />
          </Route>
          <Route path={`${parentUrl}/returns`}>
            <Returns />
          </Route>
          <Route path={`${parentUrl}/cancels`}>
            <Cancels />
          </Route>
          <Route path={`${parentUrl}/ready`}>
            <Ready />
          </Route>
          <Route path={`${parentUrl}/commissions`}>
            <Commissions />
          </Route>
          <Route path={`${parentUrl}/insuranceExpiry`}>
            <InsuranceExpiry />
          </Route>
          <Route path={`${parentUrl}/deposits`}>
            <Deposits />
          </Route>
          <Route path={`${parentUrl}/onlineUsers/:id`}>
            <UserDetails />
          </Route>
          <Route path={`${parentUrl}/onlineUsers`}>
            <OnlineUsers />
          </Route>
          <Route path={`${parentUrl}/onlineDrivers`}>
            <OnlineDrivers />
          </Route>

          <Route exact path={parentUrl}>
            <List>
              {allChilds
                .filter((r) => hasRule(r.slug))
                .map((r, i) => {
                  return (
                    <ListItem key={i} button>
                      <ListItemText
                        onClick={() =>
                          history.push(`/protected/admin${r.path}`)
                        }
                      >
                        {r.name}
                      </ListItemText>
                    </ListItem>
                  );
                })}
            </List>
          </Route>
        </Switch>
      </FullCard>
    </Provider>
  );
};

export default Reports;
